<template>
  <div class="info">
    <div class="info__title">
      {{ address.Title }}
    </div>
    <div class="info__body">
      <div>
        <c-icon
          name="map-address"
          size="ssm"
          color="#074E8E"
        />
        <div>
          <p v-if="address.StreetAddress">
            {{ address.StreetAddress }}
          </p>
          <p>{{ address.City }} {{ address.State }} {{ address.Country }}</p>
        </div>
      </div>
      <div v-if="address.PostalCode">
        <c-icon
          name="map-postalCode"
          size="ssm"
          color="#074E8E"
        />
        <p>{{ address.PostalCode }}</p>
      </div>
      <div v-if="address.Phone">
        <c-icon
          name="map-phone"
          size="ssm"
          color="#074E8E"
        />
        <p>{{ address.Phone }}</p>
      </div>
      <div v-if="address.Fax">
        <c-icon
          name="map-fax"
          size="ssm"
          color="#074E8E"
        />
        <p>{{ address.Fax }}</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MapV2Info',
  props: {
    address: {
      type: Object,
      default: null
    }
  }
}
</script>
